import { ModifierDetail } from "@/core/models";
import { BaseModifierPriceCalculationStrategy } from ".";

export class RegularModifierPriceStrategy extends BaseModifierPriceCalculationStrategy {

  protected extractFactorPrice(modifierDetail: ModifierDetail): bigint {
    return BigInt(modifierDetail?.precio ?? 0n);
  }
}